import { jsx as n } from "react/jsx-runtime";
import { omit as m } from "es-toolkit/compat";
import a from "../../utils/classNames.js";
const i = ({
  className: t,
  children: o,
  ...e
}) => {
  const r = a("ActionBarItemPopoverContent", t), s = m(e, ["title", "useOffscreen"]);
  return /* @__PURE__ */ n("div", { ...s, className: r, children: o });
};
i.displayName = "ActionBarItemPopoverContent";
export {
  i as default
};
//# sourceMappingURL=ActionBarItemPopoverContent.js.map
